import React from 'react';
import {
  InputGroup, InputGroupAddon, Input, Button
} from 'reactstrap';


const CompanySearchBar = (props) => {
  const {
    searchText,
    updateSearchText,
    onClickSearch
  } = props;

  return (
    <InputGroup>
      <Input
        size="sm"
        placeholder="Introduce tu búsqueda aquí"
        value={searchText ?? ''}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            onClickSearch();
          }
        }}
        onChange={(event) => updateSearchText(event.target.value)} />
      <InputGroupAddon addonType="append">
        <Button size="sm" onClick={onClickSearch}><i className="fa fa-search"/></Button>
      </InputGroupAddon>
    </InputGroup>
  );
}

export default CompanySearchBar;
